import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import Brands from '../pages/Brands'
import CreateBrand from "pages/Brands/Create";
import NewBrand from "pages/Brands/New";
import EditBrand from "pages/Brands/Edit";
import Users from "pages/Users";
import CreateUser from 'pages/Users/Create'
import EditUser from 'pages/Users/Edit'

import Campaigns from "pages/Campaigns";
import CampaignDetails from "pages/Campaigns/CampaignDetails";
import CampaignRequirement from "pages/Campaigns/Requirement";
import CampaignCreatives from "pages/Campaigns/Creatives";
import CampaignApplications from "pages/Campaigns/Applications";
import CampaignCollaborations from "pages/Campaigns/Collaborations";
import CampaignMilestones from "pages/Campaigns/Milestones";
import CampaignInsights from "pages/Campaigns/Insights";
import Campaign from "pages/Campaigns/Campaign";
import RecommendedCreators from "pages/Campaigns/RecommendedCreators";
import CampaignInvites from "pages/Campaigns/Invitation";
import Login from "pages/Authentication/Login";
import CollaborationMilestone from "pages/Campaigns/Collaborations/Collaboration/Collaboration";
import CollaborationsBulkProcess from "pages/Campaigns/Collaborations/BulkProcess";
import CampaignPermalinks from "pages/Campaigns/Permalinks";
import ContentLibrary from "pages/Campaigns/ContentLibrary";
import CollaborationChat from "pages/Campaigns/Collaborations/Collaboration/Chat";
import CampaignInfo from "pages/Campaigns/Edit/CampaignInfo";
import CampaignProduct from "pages/Campaigns/Edit/CampaignProduct";
import CampaignCreators from "pages/Campaigns/Edit/CampaignCreators";
import CampaignDeliverables from "pages/Campaigns/Edit/CampaignDeliverables";
import CampaignControls from "pages/Campaigns/Edit/CampaignControls";
import CampaignPaymentTerms from "pages/Campaigns/Edit/CampaignPaymentTerms";
import CampaignCreativesV2 from "pages/Campaigns/Edit/CampaignCreatives";
import Wallet from "pages/Wallet";
import ConnectIG from "pages/ConnectIG";
import SocialAccounts from "pages/SocialAccount/SocialAccounts";
import SocialAccount from "pages/SocialAccount/SocialAccount";
import CreatorMarketplace from "pages/CreatorMarketplace";
import TrackedPosts from "pages/SocialAccount/TrackedPosts";
import CompetitorAnalysis from "pages/CompetitorAnalysis";
import CompetitionGroup from "pages/CompetitorAnalysis/CompetitionGroup";
import CompetitionGroupPublic from "pages/CompetitorAnalysis/CompetitonGroupPublic";
import PublicLayout from "Layouts/PublicLayout";
import Dashbaord from "pages/Dashboard";
import Onboarding from "pages/Onboarding";
import Collections from "pages/Collection";
import Collection from "pages/Collection/Collection";
import SubscriptionPlans from "pages/Membership/SubscriptionPlans";
import TrialActive from "Components/membership/TrialActive";
import SubscriptionCheckout from "pages/Membership/SubscriptionCheckout";
import CreateCampaign from "pages/Campaigns/CreateCampaign";
import CreateCampaignAIAuto from "pages/Campaigns/Create/CreateCampaignAIAuto";
import CreateCampaignAIBrief from "pages/Campaigns/Create/CreateCampaignAIBrief";
import ShortlistedApps from "pages/Campaigns/Applications/ShortlistedApps";
import CreatorDiscovery from "pages/CreatorDiscovery";
import Creators from "pages/Creators";

const authProtectedRoutes = [
  { path: '/', exact: true, component: <Dashbaord />},

  //Brands
  { path: '/brand', exact: true, component: <Brands /> },
  { path: '/brand/create', exact: true, component: <NewBrand /> },
  { path: '/brand/new', exact: true, component: <NewBrand /> },
  { path: '/brand/:brandId/edit', exact: true, component: <EditBrand /> },

  //Users
  { path: '/user', exact: true, component: <Users /> },
  { path: '/user/create', exact: true, component: <CreateUser /> },
  { path: '/user/:userId/edit', exact: true, component: <EditUser /> },

  //Campaigns
  { path: '/campaign', exact: true, component: <Campaigns /> },
  { path: '/campaign/new', exact: true, component: <CreateCampaign /> },
  { path: '/campaign/create', exact: true, component: <CampaignInfo /> },
  { path: '/campaign/create/ai-brief', exact: true, component: <CreateCampaignAIBrief /> },
  { path: '/campaign/create/ai-auto', exact: true, component: <CreateCampaignAIAuto /> },
  { path: '/campaign/:campaignId', exact: true, component: <Campaign /> },
  { path: '/campaign/:campaignId/v1/edit', exact: true, component: <CampaignDetails /> },
  { path: '/campaign/:campaignId/edit', exact: true, component: <CampaignInfo /> },
  { path: '/campaign/:campaignId/requirement', exact: true, component: <CampaignRequirement /> },
  { path: '/campaign/:campaignId/gigs', exact: true, component: <CampaignProduct /> },
  { path: '/campaign/:campaignId/creators', exact: true, component: <CampaignCreators /> },
  { path: '/campaign/:campaignId/deliverables', exact: true, component: <CampaignDeliverables /> },
  { path: '/campaign/:campaignId/payment-terms', exact: true, component: <CampaignPaymentTerms /> },
  { path: '/campaign/:campaignId/controls', exact: true, component: <CampaignControls /> },
  { path: '/campaign/:campaignId/banner', exact: true, component: <CampaignCreativesV2 /> },
  { path: '/campaign/:campaignId/creative', exact: true, component: <CampaignCreatives /> },
  { path: '/campaign/:campaignId/milestone', exact: true, component: <CampaignMilestones /> },
  { path: '/campaign/:campaignId/applications', exact: true, component: <CampaignApplications /> },
  { path: '/campaign/:campaignId/shortlisted', exact: true, component: <ShortlistedApps /> },
  { path: '/campaign/:campaignId/collaborations', exact: true, component: <CampaignCollaborations /> },
  { path: '/campaign/:campaignId/collaborations/bulk-process', exact: true, component: <CollaborationsBulkProcess /> },
  { path: '/collaboration', exact: true, component: <CollaborationMilestone /> },
  { path: '/collaboration/campaign/:campaignId/collaboration/:collaborationId/milestone/:milestoneId', exact: true, component: <CollaborationMilestone /> },
  { path: '/collaboration/campaign/:campaignId/collaboration/:collaborationId', exact: true, component: <CollaborationMilestone /> },
  { path: '/campaign/:campaignId/insights', exact: true, component: <CampaignInsights /> },
  { path: '/campaign/:campaignId/recommended-creators', exact: true, component: <RecommendedCreators /> },
  { path: '/campaign/:campaignId/invites', exact: true, component: <CampaignInvites /> },
  { path: '/campaign/:campaignId/add-posts', exact: true, component: <CampaignPermalinks /> },
  { path: '/content-library', exact: true, component: <ContentLibrary /> },
  { path: '/chat', exact: true, component: <CollaborationChat /> },
  { path: '/chat/:uuid', exact: true, component: <CollaborationChat /> },
  { path: '/wallet', exact: true, component: <Wallet /> },
  { path: '/c/ig', exact: true, component: <ConnectIG /> },
  { path: '/social-account', exact: true, component: <SocialAccounts /> },
  { path: '/social-account/:socialAccountId', exact: true, component: <SocialAccount /> },
  { path: '/creator-marketplace', exact: true, component: <CreatorMarketplace /> },
  { path: '/track-media', exact: true, component: <TrackedPosts /> },
  { path: '/competitor', exact: true, component: <CompetitorAnalysis /> },
  { path: '/competitor/:competitionGroupId', exact: true, component: <CompetitionGroup /> },
  { path: '/competitor/:competitionGroupId/creators', exact: true, component: <CompetitionGroup /> },
  { path: '/competitor/:competitionGroupId/content', exact: true, component: <CompetitionGroup /> },
  { path: '/onboarding', exact: true, component: <Onboarding />, onboarding: true },
  { path: '/collection', exact: true, component: <Collections />},
  { path: '/collection/:collectionId', exact: true, component: <Collection />},
  { path: '/subscription-plans', exact: true, component: <SubscriptionPlans />},
  { path: '/subscription-plans/trial', exact: true, component: <TrialActive />},
  { path: '/subscription-plans/checkout', exact: true, component: <SubscriptionCheckout />},
  { path: '/creator-discovery', exact: true, component: <CreatorDiscovery /> },
  { path: '/creator-discovery/:discoveryId', exact: true, component: <CreatorDiscovery /> },
  { path: '/creators', exact: true, component: <Creators /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: '/share/competitor/:competitionGroupShareId', exact: true, component: <PublicLayout><CompetitionGroupPublic /></PublicLayout> },
];

export { authProtectedRoutes, publicRoutes };